export default __webpack_public_path__ + "locales/es/VersionHistory.json?hash=b57926f38bc87e64a14b114556f8b44d";